/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".page-title[_ngcontent-%COMP%]{color:#004aad}.btn[_ngcontent-%COMP%]{background-color:#e9e0e0;color:#312c2c;border:#ffebcd}@keyframes custom-progress-spinner-color{0%,to{stroke:#004aad}40%{stroke:#004aad}66%{stroke:#004aad}80%,90%{stroke:#004aad}}body[_ngcontent-%COMP%], html[_ngcontent-%COMP%]{font-family:Montserrat,sans-serif!important}"];
export { styles as styles };

